
import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";




const storeApi = (set) => ({
    
    itemActivo: null,
    items: [],

    setActivarItem: (value) => set({ itemActivo: value }),
    

    // Agregar un item
    agregarItem: (nuevoItem) => set((state) => ({
        items: [...state.items, nuevoItem],
    })),


    // Eliminar un item por ID
    eliminarItem: (id) => set((state) => ({
        items: state.items.filter(item => item.id !== id),
    })),


    limpiarItems: () => set({ items: [], itemActivo: null }),
    
});






export const useCarritoClienteStore = create()(
    devtools(
        persist(
            storeApi,
            { name: 'carrito-storage' }
        )
    )
)
